import React, { useState, useEffect } from 'react'
import TagsBlock from './TagsBlock/TagsBlock'
import { makeStyles } from '@material-ui/core/styles'
import {
  Input,
  InputLabel,
  MenuItem,
  FormControl,
  ListItemText,
  Select,
  Checkbox,
  Typography,
} from '@material-ui/core'
import style from './index.module.scss'
import { connect } from 'react-redux'
import { getAllMarksForMapAction } from '../../../redux/actions/existingCoords'
import { useDispatch } from 'react-redux'

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    bottom: '13px',
    width: '360px',
    minWidth: '111px',
    margin: '0',
    marginTop: '10px',
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
}))

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
}

const TagsHeader = (props) => {
  const classes = useStyles()
  const [tagsItems, setTags] = useState([])
  const dispatch = useDispatch()

  useEffect(() => {
    const formatTagsArray = tagsItems.map((str) => {
      const item = props.tagsData.filter((el) => el.name === str)
      if (item.length === 1) return item[0].id
    })
    if (tagsItems && props.map?.id) {
      dispatch(getAllMarksForMapAction(props.map?.id, formatTagsArray))
    }
  }, [tagsItems, props.map?.id])

  const handleChange = (event) => {
    setTags(event.target.value)
    const tagId = []
    props.tagsData.map((item) => {
      for (let i = 0; i < event.target.value.length; i++) {
        if (item.name === event.target.value[i]) {
          tagId.push(item.id)
        }
      }
    })
  }

  const handleDeleteTags = (event) => {
    const { name } = event.currentTarget
    const filteredTags = tagsItems.filter((el) => el !== name)
    setTags(filteredTags)
    const tagId = []

    props.tagsData.map((el) => {
      for (let i = 0; i < filteredTags.length; i++) {
        if (filteredTags[i] === el.name) {
          tagId.push(el.id)
        }
      }
    })
  }

  const setAllTags = () => {
    const namesArray = props.tagsData.map((item) => item.name)
    const tagsId = props.tagsData.map((item) => item.id)
    setTags(namesArray)
  }

  const unsetAllTags = () => {
    setTags([])
  }

  const tagClassName = (name) =>
    /expert|beginner|intermediate/i.test(name)
      ? style.levelTag
      : /(steep|mellow|dense|open) trees/i.test(name)
      ? style.treesTag
      : style.tag

  return (
    <div className={style.tagsHeaderWrapper}>
      <FormControl className={classes.formControl}>
        <InputLabel className={style.inputLabel}>Select Tags</InputLabel>
        <Select
          labelId="demo-mutiple-checkbox-label"
          multiple
          value={tagsItems}
          onChange={handleChange}
          input={<Input />}
          renderValue={(selected) => selected.join(', ')}
          MenuProps={MenuProps}
        >
          {props.tagsData.map((tag) => (
            <MenuItem key={tag.id} value={tag.name}>
              <Checkbox checked={tagsItems.indexOf(tag.name) > -1} />
              <ListItemText
                className={tagClassName(tag.name)}
                disableTypography
                primary={
                  <Typography
                    type="body2"
                    style={{
                      fontFamily: "'Bebas Neue', cursive",
                      fontSize: '18px',
                      lineHeight: 2,
                    }}
                  >
                    {tag.name}
                  </Typography>
                }
              />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <TagsBlock
        tags={tagsItems}
        handleDeleteTags={handleDeleteTags}
        setAllTags={setAllTags}
        unsetAllTags={unsetAllTags}
      />
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    tagsData: state.general.tags,
    map: state.map.map,
  }
}

const mapDispatchToProps = {
  getAllMarksForMapAction,
}

export default connect(mapStateToProps, mapDispatchToProps)(TagsHeader)
